import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import { isWeaponType, isArmorType, isEnhancedItem } from '@/types/lootTypes';
import { chain, startCase, intersection } from 'lodash';
import MySelect from '@/components/MySelect.vue';
import VueMarkdown from 'vue-markdown';
const equipmentModule = namespace('equipment');
const enhancedItemsModule = namespace('enhancedItems');
let CharacterSheetEquipmentAdder = class CharacterSheetEquipmentAdder extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.selected = '';
        this.quantity = 1;
        this.equipped = false;
        this.attuned = false;
        this.category = 'All Equipment';
        this.categories = ['All Equipment', 'Armor', 'Weapon', 'Adventuring Gear', 'Enhanced Items'];
        this.type = 'All Types';
        this.startCase = startCase;
        this.isEnhancedItem = isEnhancedItem;
    }
    typeField(equipment) {
        if (isEnhancedItem(equipment))
            return 'type';
        else if (isWeaponType(equipment))
            return 'weaponClassification';
        else if (isArmorType(equipment))
            return 'armorClassification';
        else
            return 'equipmentCategory';
    }
    typeText(equipment) {
        if (isEnhancedItem(equipment))
            return equipment.type;
        else if (isWeaponType(equipment))
            return equipment.weaponClassification;
        else if (isArmorType(equipment))
            return equipment.armorClassification;
        else
            return equipment.equipmentCategory;
    }
    get allItems() {
        return [...this.enhancedItems, ...this.equipment];
    }
    get types() {
        return [
            { text: 'All Types', value: 'All Types' },
            ...chain(this.allItems)
                .filter(this.isRightCategory)
                .uniqBy(this.typeText)
                .map(equipment => ({
                text: startCase(this.typeText(equipment)),
                value: this.typeText(equipment)
            }))
                .sortBy('value')
                .value()
        ];
    }
    get filteredEquipment() {
        return this.allItems.filter(equipment => this.isRightCategory(equipment) && (!this.type ||
            this.type === 'All Types' ||
            this.type === this.typeText(equipment))).map(({ name }) => name);
    }
    get selectedEquipment() {
        return this.allItems.find(({ name }) => name === this.selected);
    }
    get isEquippable() {
        if (!this.selectedEquipment || isEnhancedItem(this.selectedEquipment))
            return false;
        // else if (isEnhancedItem(this.selectedEquipment)) {
        // return this.selectedEquipment && ['Weapon', 'Armor', 'Shield', 'Focus'].includes(this.selectedEquipment.type)
        else {
            return this.selectedEquipment && ['Weapon', 'Armor'].includes(this.selectedEquipment.equipmentCategory);
        }
    }
    get isAttuneable() {
        return this.selectedEquipment && isEnhancedItem(this.selectedEquipment) && this.selectedEquipment.requiresAttunement;
    }
    get atAttunementLimit() {
        return this.selectedEquipment &&
            isEnhancedItem(this.selectedEquipment) &&
            this.attunement.current + (intersection(this.selectedEquipment.rarityOptions, ['Legendary', 'Artifact']).length > 0 ? 2 : 1) > this.attunement.maximum;
    }
    isRightCategory(equipment) {
        return !this.category ||
            this.category === 'All Equipment' ||
            (isEnhancedItem(equipment) && this.category === 'Enhanced Items') ||
            (!isEnhancedItem(equipment) && (this.category === equipment.equipmentCategory || (this.category === 'Adventuring Gear' &&
                !['Weapon', 'Armor'].includes(equipment.equipmentCategory))));
    }
    onCategoryChange() {
        this.type = '';
        this.onTypeChange();
    }
    onTypeChange() {
        this.selected = '';
    }
    onSelectionChange() {
        this.attuned = false;
    }
    resetValues() {
        this.selected = '';
        this.quantity = 1;
        this.equipped = false;
        this.attuned = false;
        this.category = 'All Equipment';
        this.type = 'All Types';
    }
    addItem() {
        if (this.selectedEquipment) {
            this.$emit('updateCharacter', { equipment: { [this.position]: {
                        name: this.selected,
                        quantity: this.quantity,
                        category: isEnhancedItem(this.selectedEquipment) ? 'EnhancedItem' : 'Equipment',
                        ...(this.isEquippable ? { equipped: this.equipped } : {}),
                        ...(this.isAttuneable ? { attuned: this.attuned } : {})
                    } } });
            this.isOpen = false;
        }
    }
};
__decorate([
    Prop(Number)
], CharacterSheetEquipmentAdder.prototype, "position", void 0);
__decorate([
    Prop(Object)
], CharacterSheetEquipmentAdder.prototype, "attunement", void 0);
__decorate([
    equipmentModule.State
], CharacterSheetEquipmentAdder.prototype, "equipment", void 0);
__decorate([
    enhancedItemsModule.State
], CharacterSheetEquipmentAdder.prototype, "enhancedItems", void 0);
CharacterSheetEquipmentAdder = __decorate([
    Component({
        components: {
            MyDialog,
            MySelect,
            VueMarkdown
        }
    })
], CharacterSheetEquipmentAdder);
export default CharacterSheetEquipmentAdder;
